import React, { Component } from 'react';
import { DatePicker, message, Select, Button } from 'antd';
import moment from 'moment';
import API_URL from '../../../common/url';
import $ from '../../../common/AjaxRequest';
import DateRange from '../../common/DateRange';
import SearchSelect from '../../common/SearchSelect';

const { Option } = Select;
const { RangePicker, MonthPicker } = DatePicker;
const MonthFormat = 'YYYY-MM';
const DateFormat = 'YYYY-MM-DD';

class DetailRecord extends Component {
    state = {
        searchParams: {
            startDate: `${moment().add(-1,'M').format(MonthFormat)}-26`,
            endDate: `${moment().format(MonthFormat)}-25`,
        },
        showInv: true,
        showSite: true,
        invOptions: [],
        siteOptions: [],
        roleList: [],
        typeList: [],
        workContentList: [],
    }

    search = () => {
        const { searchParams, invOptions, siteOptions } = this.state;
        const params = { ...searchParams };
        const { investigationId, investigationSiteId } = params;
        if (investigationId) {
            const flag = invOptions.some(item => {
                return item.value == investigationId;
            });
            if (!flag) {
                params.investigationId = '';
            }
        }
        if (investigationSiteId) {
            const flag = siteOptions.some(item => {
                return item.value == investigationSiteId;
            });
            if (!flag) {
                params.investigationSiteId = '';
            }
        }
        this.props.search(params);
    }

    export = () => {
        const { searchParams } = this.state;
        this.props.export(searchParams);
    }

    getRoleList = () => {
        const options = {
            url: `${API_URL.manhour.listAllRoles}`,
            data: {},
            dataType: 'json',
            doneResult: ( res => {
                this.setState({ roleList: res.datas });
            }),
        };
        $.sendRequest(options);
    }

    getTypeList = () => {
        const options = {
            url: API_URL.manhour.queryEnterpriseNameAll,
            data: {},
            dataType: 'json',
            doneResult: ( res => {
                this.setState({ typeList: res.data });
            }),
        };
        $.sendRequest(options);
    }

    onChangeRangeTime = value => {
        const { searchParams } = this.state;
        if(value.length == 1){
            searchParams.startDate = value[0].format(DateFormat);
        }
        else if(value.length == 2){
            searchParams.startDate = value[0].format(DateFormat);
            searchParams.endDate = value[1].format(DateFormat);
        }else{
           searchParams.startDate = '';
           searchParams.endDate = '';
        }
        this.setState({searchParams});
    }

    //项目
    invSelectChanged = value => {   
        const { searchParams } = this.state;
        if (value) {
            searchParams.investigationId = value.key;
        } else {
            searchParams.investigationId = '';
        }
        searchParams.investigationSiteId = '';
        this.setState({
            searchParams,
            showSite: false,
            siteOptions: [],
        }, () => {
            this.setState({ showSite: true });
        });
    }

    parseInvData = (res, value) => {
        if (res.data || res.datas) {
            const sourceData = res.data || res.datas;
            const data = sourceData.map(item => ({
                text: `${item.investigationName}`,
                value: item.investigationId,
            }));
            this.setState({ invOptions: data });
        } else {
            this.setState({ invOptions: [] });
        }
    };

    //中心
    siteSelectChanged = value => {   
        const { searchParams } = this.state;
        if (value) {
            searchParams.investigationSiteId = value.key;
        } else {
            searchParams.investigationSiteId = '';
        }
        this.setState({searchParams});
    }

    parseSiteData = (res, value) => {
        if (res.data || res.datas) {
            const sourceData = res.data || res.datas;
            const data = sourceData.map(item => ({
                text: `${item.investigationSiteName}`,
                value: item.investigationSiteId,
            }));
            this.setState({ siteOptions: data });
        } else {
            this.setState({ siteOptions: [] });
        }
    };

    getDynamicParams = () => {
        const { searchParams, invOptions } = this.state;
        const { investigationId } = searchParams;
        if (investigationId){
            const flag = invOptions.some(item => {
                return item.value == investigationId;
            });
            if (!flag) {
                message.warning('请选择正确的临床项目');
                return;
            } else {
                return {investigationId};
            }
        }
        message.warning('请先选择临床项目');
        return null;
    }

    getWorkContentList = () => {
        const { searchParams } = this.state;
        const { enterpriseWorkNameId = '' } = searchParams;
        if (enterpriseWorkNameId == '') {
            message.warning('请先选择工作类型');
            return;
        }
        const options = {
            url: `${API_URL.manhour.queryInvestigationEnterpriseWorkName}`,
            data: {
                enterpriseWorkNameId: enterpriseWorkNameId,
            },
            dataType: 'json',
            doneResult: ( res => {
                this.setState({ workContentList: res.data });
            }),
        };
        $.sendRequest(options);
    }

    handleChange = (value, key) => {
        const { searchParams } = this.state;
        searchParams[key] = value;
        if (key === 'lineOfBusiness') {
            searchParams.secondLineName = undefined;
        }
        this.setState({searchParams});
    }

    disabledDate = (current) => {
        const { currentDate } = this.props;
        const curNum = Number(current.format('YYYYMMDD'));
        const startNum = Number(moment(currentDate).add(-3, 'M').startOf('month').format('YYYYMMDD'));
        return curNum < startNum
    }

    render () {
        const { businessList } = this.props;
        const { searchParams, invOptions, siteOptions, roleList, typeList, workContentList, showInv, showSite } = this.state;
        const { startDate, endDate, enterpriseWorkTypeId, investigationId, lineOfBusiness } = searchParams;
        const secondLineSet = new Set();
        businessList.forEach(i => {
            if (lineOfBusiness == i.typeConfigureId) {
                (i.childList || []).forEach(j => secondLineSet.add(j.typeValue));
            }
        });

        const businessOption = businessList.map(i => <Option key={i.typeConfigureId} value={i.typeConfigureId}>{i.typeValue}</Option>);
        const secondLineOption = [...secondLineSet].map(i => <Option key={i}>{i}</Option>);
        const workContentOptions = workContentList.map(d => <Option key={d.enterpriseWorkTypeId} value={d.enterpriseWorkTypeId}>{d.enterpriseWorkTypeName + '(' + d.enterpriseWorkTypeCode + ')'}</Option>);
        const roleOptions = roleList.map(d => <Option key={d.roleId}>{d.roleCode}</Option>);
        const typeOptions = typeList.map(d => <Option key={d.enterpriseWorkNameId}>{d.enterpriseWorkNameValue}</Option>);
        const { curRole } = sessionStorage;
        return (
            <div className="filter-bar bar2 work-data-bar"  key='detail'>
                <div className="form-item">
                    <label className="ui-label">工作日期</label>
                    <RangePicker
                        onChange={this.onChangeRangeTime}
                        allowClear={false}
                        disabledDate={curRole === 'CRC' ? this.disabledDate : undefined}
                        format={DateFormat}
                        defaultValue={[moment(startDate), moment(endDate)]}
                    />
                </div>
                <div className="form-item">
                    <label className="ui-label">临床项目</label>
                    {
                        showInv && 
                        <SearchSelect 
                            style={{width:200}}
                            url = {API_URL.manhour.queryMyInvestigation}
                            searchKey = 'keyword'
                            sourceData={invOptions}
                            parserData={this.parseInvData}
                            watchValue={this.invSelectChanged}
                            handleSelect = {this.invSelectChanged}
                            placeholder={'输入项目或编号自动检索'}
                            allowClear={true}
                            className='w-200-select'
                        />
                    }
                </div>
                <div className="form-item">
                    <label className="ui-label">中心</label>
                    {
                        showSite &&
                            <SearchSelect 
                            style={{width:200}}
                            url = {API_URL.manhour.queryMyInvestigationSite}
                            searchKey = 'keyword'
                            sourceData={siteOptions}
                            searchParam={{investigationId}}
                            parserData={this.parseSiteData}
                            watchValue={this.siteSelectChanged}
                            handleSelect = {this.siteSelectChanged}
                            getDynamicParams = {this.getDynamicParams}
                            placeholder={'输入中心或编号自动检索'}
                            allowClear={true}
                            className='w-200-select'
                        />
                    }
                </div>
                <div className="form-item">
                    <label className="ui-label">角色</label>
                    <Select placeholder="请选择" allowClear={true} style={{ width: 80 }} onChange={value => this.handleChange(value, 'roleId')} onFocus={this.getRoleList}>
                        { roleOptions }
                    </Select>
                </div>
                <div className="form-item">
                    <label className="ui-label">工作类型</label>
                    <Select placeholder="请选择" allowClear={true} style={{ width: 160 }} onChange={value => this.handleChange(value, 'enterpriseWorkNameId')} onFocus={this.getTypeList}>
                        { typeOptions }
                    </Select>
                </div>
                <div className="form-item">
                    <label className="ui-label">工作内容</label>
                    <Select placeholder="请选择" allowClear={true} style={{ width: 200 }} value={enterpriseWorkTypeId} onChange={value => this.handleChange(value, 'enterpriseWorkTypeId')} onFocus={this.getWorkContentList}>
                        {workContentOptions}
                    </Select>
                </div>
                <div className="form-item">
                    <label className="ui-label">状态</label>
                    <Select placeholder="请选择" allowClear={true} style={{ width: 100 }} onChange={value => this.handleChange(value, 'status')}>
                        <Option value="UNVERIFY">待确认</Option>  
                        <Option value="VERIFY">已确认</Option>
                    </Select>
                </div>
                <div className="form-item">
                    <label htmlFor="" className="ui-label">业务线</label>
                    <Select
                        allowClear={true}
                        placeholder="请选择"
                        style={{width: 120}}
                        value={lineOfBusiness}
                        onChange={value => this.handleChange(value, 'lineOfBusiness')}
                    >
                        {businessOption}
                    </Select>
                </div>
                <div className="form-item">
                    <label className="ui-label">执行业务线二级分类</label>
                    <Select
                        allowClear={true}
                        placeholder="请选择"
                        style={{width: 120}}
                        disabled={!lineOfBusiness}
                        value={searchParams.secondLineName}
                        onChange={value => this.handleChange(value, 'secondLineName')}
                    >
                        {secondLineOption}
                    </Select>
                </div>
                <Button type="primary" onClick={this.search}>搜索</Button>
                <Button type="primary" onClick={this.export}>导出</Button>
            </div>
        )
    }
}

class TotalRecord extends Component {
    state = {
        searchParams: {
            startDate: moment().format(MonthFormat),
            endDate: moment().format(MonthFormat),
        },
        showSite: true,
        invOptions: [],
        siteOptions: [],
        roleList: [],
    }

    search = () => {
        const { searchParams, invOptions, siteOptions } = this.state;
        const params = { ...searchParams };
        const { investigationId, investigationSiteId } = params;
        if (investigationId) {
            const flag = invOptions.some(item => {
                return item.value == investigationId;
            });
            if (!flag) {
                params.investigationId = ''
            }
        }
        if (investigationSiteId) {
            const flag = siteOptions.some(item => {
                return item.value == investigationSiteId;
            });
            if (!flag) {
                params.investigationSiteId = ''
            }
        }
        this.props.search(params);
    }

    export = () => {
        const { searchParams } = this.state;
        this.props.export(searchParams);
    }

    getDate = (params, date) => {
        const { searchParams } = this.state;
        searchParams.startDate = date.begin;
        searchParams.endDate = date.end;
        this.setState({ searchParams });      
    }

    getRoleList = () => {
        const options = {
            url: `${API_URL.manhour.listAllRoles}`,
            data: {},
            dataType: 'json',
            doneResult: ( res => {
                this.setState({ roleList: res.datas });
            }),
        };
        $.sendRequest(options);
    }

    //项目
    invSelectChanged = value => {   
        const { searchParams } = this.state;
        if (value) {
            searchParams.investigationId = value.key;
        } else {
            searchParams.investigationId = '';
        }
        searchParams.investigationSiteId = '';
        this.setState({
            searchParams,
            showSite: false,
            siteOptions: [],
        }, () => {
            this.setState({ showSite: true });
        });
    }

    parseInvData = (res, value) => {
        if (res.data || res.datas) {
            const sourceData = res.data || res.datas;
            const data = sourceData.map(item => ({
                text: `${item.investigationName}`,
                value: item.investigationId,
            }));
            this.setState({ invOptions: data });
        } else {
            this.setState({ invOptions: [] });
        }
    };

    //中心
    siteSelectChanged = value => {   
        const { searchParams } = this.state;
        if (value) {
            searchParams.investigationSiteId = value.key;
        } else {
            searchParams.investigationSiteId = '';
        }
        this.setState({searchParams});
    }

    parseSiteData = (res, value) => {
        if (res.data || res.datas) {
            const sourceData = res.data || res.datas;
            const data = sourceData.map(item => ({
                text: `${item.investigationSiteName}`,
                value: item.investigationSiteId,
            }));
            this.setState({ siteOptions: data });
        } else {
            this.setState({ siteOptions: [] });
        }
    };

    getDynamicParams = () => {
        const { searchParams, invOptions } = this.state;
        const { investigationId } = searchParams;
        if (investigationId){
            const flag = invOptions.some(item => {
                return item.value == investigationId;
            });
            if (!flag) {
                message.warning('请选择正确的临床项目');
                return;
            } else {
                return {investigationId};
            }
        }
        message.warning('请先选择临床项目');
        return null;
    }

    handleChange = (value, key) => {
        const { searchParams } = this.state;
        searchParams[key] = value;
        if (key === 'lineOfBusiness') {
            searchParams.secondLineName = undefined;
        }
        this.setState({searchParams});
    }

    componentDidMount(){
        const param = this.props.MyHourParams;
        const Type = this.props.chooseType;
        if (Type == "total") {
            if (param) {
                if((location.href.indexOf('investigation') > -1)||(location.href.indexOf('daily') > -1)){
                    const searchParamsNew = {};
                    searchParamsNew.hourType = param.investigation;
                    searchParamsNew.relateId= param.relateId;
                    this.props.search({...searchParamsNew});
                }
            }
        }
    }

    disabledDate = (current) => {
        const { currentDate } = this.props;
        const curNum = Number(current.format('YYYYMM'));
        const startNum = Number(moment(currentDate).add(-3, 'M').format('YYYYMM'));
        return curNum < startNum
    }

    render () {
        const { businessList } = this.props;
        const { searchParams, invOptions, siteOptions, roleList, showSite } = this.state;
        const { startDate, endDate, investigationId, lineOfBusiness } = searchParams;
        const { curRole } = sessionStorage;
        const secondLineSet = new Set();
        businessList.forEach(i => {
            if (lineOfBusiness == i.typeConfigureId) {
                (i.childList || []).forEach(j => secondLineSet.add(j.typeValue));
            }
        });

        const businessOption = businessList.map(i => <Option key={i.typeConfigureId} value={i.typeConfigureId}>{i.typeValue}</Option>);
        const secondLineOption = [...secondLineSet].map(i => <Option key={i}>{i}</Option>);
        const roleOptions = roleList.map(d => <Option key={d.roleId}>{d.roleCode}</Option>);
        return (
            <div className="filter-bar bar2 work-data-bar" key='total'>
                <div className="form-item">
                    <label className="ui-label">工作日期</label>
                    {/* <DateRange
                        style={{display:'flex',alignItems:'center'}}
                        defaultValueBegin={moment(startDate)}
                        defaultValueEnd={moment(endDate)}
                        next=''
                        loadData={this.getDate}
                    /> */}
                    <div style={{ 
                        display: 'flex',
                        alignItems:'center' 
                    }}>
                        <MonthPicker
                            format={MonthFormat}
                            style={{width: 200}}
                            value={startDate ? moment(startDate) : null}
                            disabledDate={curRole === 'CRC' ? this.disabledDate : undefined}
                            placeholder="选择月份"
                            onChange={(date, dateString) => this.handleChange(dateString, 'startDate')}
                        />
                        <span style={{ margin: '0px 5px' }}>至</span>
                        <MonthPicker
                            format={MonthFormat}
                            style={{width: 200}}
                            value={endDate ? moment(endDate) : null}
                            disabledDate={curRole === 'CRC' ? this.disabledDate : undefined}
                            placeholder="选择月份"
                            onChange={(date, dateString) => this.handleChange(dateString, 'endDate')}
                        />
                    </div>
                </div>
                <div className="form-item">
                    <label className="ui-label">临床项目</label>
                    <SearchSelect 
                        style={{width:200}}
                        url = {API_URL.manhour.queryMyInvestigation}
                        searchKey = 'keyword'
                        sourceData={invOptions}
                        parserData={this.parseInvData}
                        watchValue={this.invSelectChanged}
                        handleSelect = {this.invSelectChanged}
                        placeholder={'输入项目或编号自动检索'}
                        allowClear={true}
                        className='w-200-select'
                    />
                </div>
                <div className="form-item">
                    <label className="ui-label">中心</label>
                    {
                        showSite &&
                        <SearchSelect 
                            style={{width:200}}
                            url = {API_URL.manhour.queryMyInvestigationSite}
                            searchKey = 'keyword'
                            sourceData={siteOptions}
                            searchParam={{investigationId}}
                            parserData={this.parseSiteData}
                            watchValue={this.siteSelectChanged}
                            handleSelect = {this.siteSelectChanged}
                            getDynamicParams = {this.getDynamicParams}
                            placeholder={'输入中心或编号自动检索'}
                            allowClear={true}
                            className='w-200-select'
                        />
                    }
                </div>
                <div className="form-item">
                    <label className="ui-label">角色</label>
                    <Select placeholder="请选择" allowClear={true} style={{ width: 80 }} onChange={value => this.handleChange(value, 'roleId')} onFocus={this.getRoleList}>
                        { roleOptions }
                    </Select>
                </div>
                <div className="form-item">
                    <label className="ui-label">状态</label>
                    <Select placeholder="请选择" allowClear={true} style={{ width: 120 }} onChange={value => this.handleChange(value, 'status')}>
                        <Option value="UNVERIFY">待确认</Option>
                        <Option value="UNVERIFY_TO_BE_MODIFIED">待确认(待修改)</Option>
                        <Option value="UNVERIFY_MODIFIED">待确认(已修改)</Option>
                        <Option value="VERIFY">已确认</Option>
                    </Select>
                </div>
                <div className="form-item">
                    <label htmlFor="" className="ui-label">业务线</label>
                    <Select
                        allowClear={true}
                        placeholder="请选择"
                        style={{width: 120}}
                        value={lineOfBusiness}
                        onChange={value => this.handleChange(value, 'lineOfBusiness')}
                    >
                        {businessOption}
                    </Select>
                </div>
                <div className="form-item">
                    <label className="ui-label">执行业务线二级分类</label>
                    <Select
                        allowClear={true}
                        placeholder="请选择"
                        style={{width: 120}}
                        disabled={!lineOfBusiness}
                        value={searchParams.secondLineName}
                        onChange={value => this.handleChange(value, 'secondLineName')}
                    >
                        {secondLineOption}
                    </Select>
                </div>
                <Button type="primary" onClick={this.search}>搜索</Button>
                <Button type="primary" onClick={this.export}>导出</Button>
            </div>
        )
    }
}

export { DetailRecord, TotalRecord };


// WEBPACK FOOTER //
// ./src/components/manHour/hour/Filter.js